<template>
  <div id="mobile-sidebar" class="tw-fixed xl:tw-hidden tw-z-50">
    <nav class="navbar">
      <div class="navbar-container">
        <input
          class="mobile-checkbox"
          type="checkbox"
          name="mobileSidebar"
          id="mobile-sidebar-checkbox"
          ref="mobileSidebar"
        />
        <div class="hamburger-lines">
          <span class="line1"></span>
          <span class="line2"></span>
          <span class="line3"></span>
        </div>
        <div
          class="menu-items tw-absolute tw-h-screen tw-w-80 tw-bg-white tw-pt-16 tw-overflow-scroll tw-z-10"
        >
          <img
            src="@/assets/img/logo1.svg"
            class="tw-absolute tw-top-4 tw-right-10 tw-mb-6 tw-cursor-pointer"
            alt="getEquity-logo"
            @click="homePage"
          />
          <nav class="sidebar__nav">
            <section
              class="sidebar__section tw-pt-8 tw-pb-5 tw-border-black-light3 tw-border-b"
            >
              <h2 class="tw-pl-8 tw-text-xs tw-font-bold tw-text-gray-dark3">
                DASHBOARD
              </h2>
              <SidebarMenu
                title="Overview"
                href="/dashboard/overview"
                @click="closeSidebar"
              />
            </section>
            <section
              class="sidebar__section tw-pt-8 tw-pb-5 tw-border-black-light3 tw-border-b"
            >
              <h2 class="tw-pl-8 tw-text-xs tw-font-bold tw-text-gray-dark3">
                GETEQUITY TOOLS
              </h2>
              <SidebarMenu
                title="Private Raise"
                v-if="isSubscribedToProducts('PRIVATE_RAISE') && hasPermission('deal:*')"
                href="/dashboard/private-raise"
                @click="closeSidebar"
              />
              <SidebarMenu
                title="Employee Benefits"
                href="/dashboard/employee-benefits"
                @click="closeSidebar"
                v-if="isSubscribedToProducts('ESOP') && hasPermission('deal:*')"
              />
              <SidebarMenu
                title="Public Raise"
                v-if="
                  (isSubscribedToProducts('PUBLIC_RAISE') ||
                  isSubscribedToProducts('PUBLIC_RAISE_PENDING') ||
                  isSubscribedToProducts('PUBLIC_RAISE_REVIEW') ||
                  isSubscribedToProducts('PUBLIC_RAISE_REJECTED')) && hasPermission('deal:*')
                "
                href="/dashboard/public-raise"
                @click="closeSidebar"
              />
              <SidebarMenu
                v-if="isSubscribedToProducts('INVEST') && hasPermission('invest:*')"
                title="Treasury"
                href="/dashboard/invest"
                @click="closeSidebar"
              />
              <SidebarMenu
                v-if="
                  (isSubscribedToProducts('CREDIT') ||
                    this.organisationDetails?.type === 'Credit') &&
                  hasPermission('credit:*')
                "
                title="Credit Provider"
                href="/dashboard/credit-provider"
                @click="closeSidebar"
              />
              <SidebarMenu
                v-if="
                  (isSubscribedToProducts('API_KEY') ||
                    this.organisationDetails?.type === 'API KEY') &&
                  hasPermission('api:*')
                "
                title="GetEquity API"
                href="/dashboard/api-client"
                @click="closeSidebar"
              />
            </section>
            <section class="sidebar__section tw-pt-8 tw-pb-5">
              <h2 class="tw-pl-8 tw-text-xs tw-font-bold tw-text-gray-dark3">
                OTHERS
              </h2>
              <SidebarMenu
                v-if="hasPermission('team:*')"
                title="Teams"
                href="/dashboard/teams"
                @click="closeSidebar"
              />
              <SidebarMenu
                v-if="hasPermission('wallet:*')"
                title="Wallet"
                href="/dashboard/wallet"
                @click="closeSidebar"
              />
              <SidebarMenu
                title="Account"
                href="/dashboard/account"
                @click="closeSidebar"
              />
            </section>
            <!-- <div class="tw-h-20 tw-flex tw-items-center tw-justify-center">
              <router-link class="tw-block" :to="{ name: 'FAQ' }">
                <img
                  src="@/assets/img/question-mark.svg"
                  class="faq-btn tw-bottom-20 tw-m-auto tw-cursor-pointer"
                  alt="faq"
                />
              </router-link>
            </div> -->
            <!-- <router-link :to="{ name: 'FAQ' }">
              <img
                src="@/assets/img/question-mark.svg"
                class="faq-btn tw-absolute tw-bottom-20 tw-m-auto tw-cursor-pointer"
                alt="faq"
              />
            </router-link> -->
          </nav>
          <!-- <SidebarMenu
            title="Overview"
            href="/dashboard/overview"
            @click="closeSidebar"
          />
          <SidebarMenu
            title="Employee Benefits"
            href="/dashboard/employee-benefits"
            @click="closeSidebar"
          />
          <SidebarMenu
            title="Wallet"
            href="/dashboard/wallet"
            @click="closeSidebar"
          />
          <SidebarMenu
            title="Account"
            href="/dashboard/account"
            @click="closeSidebar"
          /> -->
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
import SidebarMenu from "@/components/navigation/SidebarMenu.vue";
import { getItem } from "@/utils/storage";
export default {
  name: "MobileSidebar",
  components: { SidebarMenu },
  data() {
    return {
      userPermissions: [],
    };
  },
  computed: {
    organisationDetails() {
      const orgInfo = getItem("org_details");
      return orgInfo;
    },
    products() {
      const orgInfo = getItem("org_details");
      const products = orgInfo?.products;
      return products;
    },
  },
  created() {
    this.loadUserPermissions();
  },
  methods: {
    homePage() {
      this.$router.push("/");
    },
    isSubscribedToProducts(product) {
      // API_KEY | PRIVATE_RAISE | INVEST | ESOP | PUBLIC_RAISE | CREDIT
      let subProducts = this.products?.split(" ");
      let sub = subProducts?.indexOf(product);
      if (sub !== -1) return product;
    },
    faqPage() {
      this.$router.push("/faqs");
    },
    closeSidebar() {
      this.$refs.mobileSidebar.checked = false;
    },
    loadUserPermissions() {
      const teamMember = getItem("team_member");

      if (teamMember) {
        const parsedPermissions = teamMember.groups?.[0]?.permissions?.[0] || [];

        console.log(parsedPermissions, "parsed");
        try {
          if (parsedPermissions) {
            if (parsedPermissions && parsedPermissions?.actions) {
              this.userPermissions = parsedPermissions?.actions;
            }
          }
        } catch (error) {
          console.error("Error parsing permissions:", error);
        }
      }
    },

    hasPermission(permission) {
      if (!this.userPermissions || this.userPermissions.length === 0) {
        return true;
      }

      if (permission.endsWith("*")) {
        const prefix = permission.slice(0, -1);
        return this.userPermissions.some((p) => p.startsWith(prefix));
      }

      return this.userPermissions.includes(permission);
    },
  },
};
</script>
<style lang="scss" scoped>
#mobile-sidebar {
  @media (max-width: 1280px) {
    .mobile-checkbox {
      position: fixed;
      top: 20px;
      left: 16px;
      width: 40px;
      height: 40px;
      opacity: 0;
      cursor: pointer;
      z-index: 60;
    }
    
    .hamburger-lines {
      position: fixed;
      top: 20px;
      left: 16px;
      width: 40px;
      height: 40px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 5px;
      z-index: 55;
      background: #f8fafc;
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      
      span {
        display: block;
        width: 20px;
        height: 2px;
        background: #0f172a;
        border-radius: 2px;
        transition: all 0.3s ease-in-out;
      }
    }
    
    .navbar-container .hamburger-lines .line1 {
      transform-origin: center;
    }
    .navbar-container .hamburger-lines .line2 {
      transition: opacity 0.2s ease-in-out;
    }
    .navbar-container .hamburger-lines .line3 {
      transform-origin: center;
    }
    .navbar .menu-items {
      transform: translate(-150%);
      transition: transform 0.5s ease-in-out;
      box-shadow: 4px 0 24px rgba(0, 0, 0, 0.1);
    }
    .navbar .menu-items .faq-btn {
      left: 50%;
      transform: translate(-50%, 0);
    }
    .navbar-container input[type="checkbox"]:checked ~ .menu-items {
      transform: translateX(0);
    }
    .navbar-container input[type="checkbox"]:checked ~ .hamburger-lines .line1 {
      transform: rotate(45deg) translateY(5px);
    }
    .navbar-container input[type="checkbox"]:checked ~ .hamburger-lines .line2 {
      opacity: 0;
    }
    .navbar-container input[type="checkbox"]:checked ~ .hamburger-lines .line3 {
      transform: rotate(-45deg) translateY(-5px);
    }
  }
}
</style>
